import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
export type MaskIconProps = {
  /** Suffix of the `mask-icon-*` class in mask-icons.css, e.g. "lock" for `mask-icon-lock`. */
  glyph: string;
  /** Background color of the mask (the glyph itself is drawn via currentColor/mask-image). */
  color: string;
  /** Sets both width and height. Overridden individually by `width`/`height` when provided. */
  size?: number | string;
  width?: number | string;
  height?: number | string;
  sx?: SxProps<Theme>;
};
export function MaskIcon(t0) {
  const $ = _c(12);
  const {
    glyph,
    color,
    size,
    width,
    height,
    sx
  } = t0;
  const t1 = `mask-icon mask-icon-${glyph}`;
  const t2 = width ?? size;
  const t3 = height ?? size;
  let t4;
  if ($[0] !== color || $[1] !== t2 || $[2] !== t3) {
    t4 = {
      width: t2,
      height: t3,
      backgroundColor: color
    };
    $[0] = color;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== sx) {
    t5 = Array.isArray(sx) ? sx : [sx];
    $[4] = sx;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = [t4, ...t5];
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t1 || $[10] !== t6) {
    t7 = <Box component="span" className={t1} aria-hidden="true" sx={t6} />;
    $[9] = t1;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}